<template>
  <div class="bto-sb-widget bto-sb-widget-category bto-sb-widget-horse-details bto-sb-sports-icon" :class="selectedSportIcon()">
    <div class="bto-sb-widget-title">
      <h3>{{sportName}}</h3>
    </div>
    <CategoryTabHR
      v-for="(tournamentId) in tournamentIds"
      @horseRaceSportName="horseRaceSportName"
      :sportName="sportName"
      :tournamentId="tournamentId"
      :key="tournamentId" />
  </div>
</template>

<script>
  import CategoryTabHR from './category-tab-hr';

  export default {
    name: 'HorseRacingCategory',
    components: {
      CategoryTabHR,
    },
    props: {
      tournamentIds: {
        type: Array,
        default: () => [],
      }
    },
    data() {
      return {
        sportName: '',
      };
    },
    methods: {
      horseRaceSportName(sname) {
        this.sportName = this.sportName || sname;
      },
      selectedSportIcon() {
        return this.$route.params.fixtureIds.startsWith('hr') ? 'horseracing' : 'greyhoundracing';
      },
    },
  };
</script>

